export const emptyId = '00000000-0000-0000-0000-000000000000';
export const defaultTaskCategoryTitle = 'Inbox';

export const getDefaultTaskCategoryId = (taskCategories) => {
  const tc = taskCategories.find((tc) => tc.taskCategoryTitle === defaultTaskCategoryTitle);
  return tc ? tc.id : emptyId;
};
